import Button from "components/_button/form/action"
import dynamic from "next/dynamic"
import { memo, useState } from "react"
import styles from "../index.module.scss"
import abTestService from "services/ab-test.service"





const InstallmentsSpecialService = () => {
    const [visible, setVisible] = useState(false)


    const renderGiftModal = () => {
        const InstallmentsModal = dynamic(() => import("./installments-modal"))

        return <InstallmentsModal visible={visible} setVisible={setVisible} />
    }

    const openInstallmentModalHandler = () => {
        abTestService.setLookingForInstallments()
        setVisible(true)
    }



    return (
        <>
            {renderGiftModal()}

            <div className={styles.item__list + " flex align-i-center gap-15"}
                onClick={openInstallmentModalHandler}
            >
                <svg width="42" height="36" viewBox="0 0 42 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M34.9916 10.18V20.0508C34.9916 25.9542 31.6182 28.4841 26.5582 28.4841H9.71073C8.84823 28.4841 8.02406 28.4076 7.2574 28.2351C6.77823 28.1584 6.31825 28.0242 5.89658 27.8709C3.02158 26.7975 1.2774 24.3058 1.2774 20.0508V10.18C1.2774 4.27663 4.65073 1.7467 9.71073 1.7467H26.5582C30.8516 1.7467 33.9374 3.56753 34.7616 7.72669C34.8957 8.49336 34.9916 9.27913 34.9916 10.18Z" stroke="#292D32" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M40.7437 15.9302V25.8011C40.7437 31.7044 37.3704 34.2343 32.3104 34.2343H15.4629C14.0445 34.2343 12.7604 34.0428 11.6487 33.6211C9.36787 32.7778 7.81535 31.0336 7.25952 28.2353C8.02619 28.4078 8.85035 28.4843 9.71285 28.4843H26.5604C31.6204 28.4843 34.9937 25.9544 34.9937 20.0511V10.1802C34.9937 9.27937 34.917 8.47443 34.7637 7.72693C38.4054 8.4936 40.7437 11.0619 40.7437 15.9302Z" stroke="#292D32" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M18.122 20.1848C20.9165 20.1848 23.182 17.9193 23.182 15.1247C23.182 12.3302 20.9165 10.0647 18.122 10.0647C15.3274 10.0647 13.062 12.3302 13.062 15.1247C13.062 17.9193 15.3274 20.1848 18.122 20.1848Z" stroke="#292D32" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M7.16162 10.9084V19.3418" stroke="#292D32" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M29.0916 10.9089V19.3423" stroke="#292D32" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                </svg>


                <div className={styles.content__item}>
                    <div className="flex align-i-center jcb w100">
                        <h4>

                            شرایط اقسط
                        </h4>

                        <Button
                            className={styles.show_gifts__content + " flex align-i-center gap-10 p-0"}
                            btnType="ghost"
                        >
                            مشاهده شرایط اقساط
                            <svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5.99998 8.96004L1.65331 5.70004C1.13998 5.31504 1.13998 4.68504 1.65331 4.30004L5.99998 1.04004" stroke="#0130A2" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </Button>
                    </div>
                    <p>
                        با ثبت قرارداد با این متخصص می‌توانید 50 درصد مبلغ را به‌صورت اقساط پرداخت کنید
                    </p>
                </div>
            </div>
        </>
    )
}

export default memo(InstallmentsSpecialService)